"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var H1_1 = require("../../../../typography/H1");
var styles = require("./Header.css");
require("./Header.desktop.css");
require("./Header.tablet.css");
var Header = function (_a) {
    var options = _a.options, data = _a.data;
    var className = options.className && options.className.length > 0
        ? (options.className += " " + styles.consoleHeader)
        : styles.consoleHeader;
    var ariaRole = "heading";
    var h1options = __assign(__assign({}, options), { className: className, role: ariaRole });
    return React.createElement(H1_1.default, { options: h1options, data: data });
};
Header.defaultProps = {
    options: {
        className: '',
    },
};
exports.default = Header;
//# sourceMappingURL=Header.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Console/components/Header/Header.js
// module id = 1350
// module chunks = 8